module.exports = {
  __depends__: [ require(170) ],
  __init__: [ 'directEditing' ],
  directEditing: [ 'type', require(115) ]
};